import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classes from './Pax.scss';
import Cleave from 'cleave.js/react';

import moment from 'moment';

import InputMaterial from '../../components/UI/InputMaterial/InputMaterial';
import InputLabel from '../../components/UI/InputLabel/InputLabel';
import paxMapping from '../../assets/json/paxMapping';
import PassportDetails from '../PassportDetails/PassportDetails';
import FrequentFlyerDetails from '../FrequentFlyerDetails/FrequentFlyerDetails';

import SelectMenu from '../../components/UI/SelectMenu/SelectMenu';

import Button from '../UI/Button/Button';
import Tooltip from '../UI/Tooltip/Tootip';

import HeadingH3 from '../UI/Headings/HeadingH3/HeadingH3';
import HeadingH4 from '../UI/Headings/HeadingH4/HeadingH4';

import AnimakitExpander from "animakit-expander";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as farePriceActions from '../../store/actions/index';
import * as hotelActions from '../../store/actions/index';

class Pax extends Component {

    constructor(props) {
        super(props);
        this.state = {
            honorific: '',
            isHonorificValid: true,
            firstName: '',
            isFirstNameValid: true,
            lastName: '',
            isLastNameValid: true,
            isDobValid: true,
            startDate: null,
            isCalendarVisible: false,
            dateRawValue: '',
            dateValue: '',
            isExtrasExpanded: false,
            number: '',
            nationality: '',
            selectedOption: {
                value : "91",
                label : "India",
                alpha_2_code: "IN"
            },
            passportExpiryDateRawValue: '',
            passportExpiryDate: '',
            frequentFlyerNumber: '',
            ffnSelectedOption: {
                value: "",
                label: ""
            }
        };
        this.handleChange = this.handleChange.bind(this);
      }

    handleChange(date) {
        this.setState({
          startDate: date
        }, () => {
            this.setState({ isCalendarVisible: false })
        });
    }

    onHandleChange = (selectedOption) => {
        let optionSelected = {...selectedOption};
        optionSelected.label = optionSelected.label.split('-')[0].trim();
        this.setState({ selectedOption: optionSelected }, () => {
            if(this.props.totalPaxConstant === 1) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        });
    }

    ffnHandleChange = (selectedOption) => {
        this.setState({ ffnSelectedOption: selectedOption }, () => {
            if(this.props.totalPaxConstant === 1) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        });
    }

    onToggleExtras = () => 
    this.setState((prevState) => {
      return { isExtrasExpanded: !prevState.isExtrasExpanded }
    })

    inputChangeHandler = (event, id) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        if(value.trim() !== " ") {
           if(id === 1 && (value.match(/^[a-zA-Z]+$/) || value === "")) {
               this.setState({ 
                    [name]: value,
                    isFirstNameValid: true
                }, () => {
                    if(this.props.totalPaxConstant === 1) {
                        this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
                    }
                });
           } else if(id === 2 && (value.match(/^[a-zA-Z]+$/) || value === "")) {
               this.setState({
                    [name]: value,
                    isLastNameValid: true
               }, () => {
                    if(this.props.totalPaxConstant === 1 && this.state.lastName.length > 2) {
                        this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
                    }
               });
           } else if(id === 3) {
               this.setState({
                   [name]: value,
                   isDobValid: true
               })
           }      
        }
    }

    inputHandler = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        this.setState({
            [name]: value
        }, () => {
            if(this.props.totalPaxConstant === 1) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        });
    }

    honorificSelectHandler = (val) => {
        this.setState({
            honorific: val,
            honorificSelectActive: false,
            isHonorificValid: true 
        }, () => {
            if(this.props.totalPaxConstant === 1) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        })
    }

    componentDidMount() {
            if((this.props.passengers.length === 1 && this.props.totalPaxConstant === 1)) {
                const pax = this.props.passengers[0];
                this.setState({
                    honorific: pax.travellerDetails.title,
                    firstName: pax.travellerDetails.firstName,
                    lastName: pax.travellerDetails.lastName,
                    dateValue: pax.travellerDetails.dateOfBirth,
                    dateRawValue: pax.travellerDetails.dobRaw,
                    number: pax.travellerDetails.passport.number,
                    nationality: pax.travellerDetails.passport.nationality,
                    selectedOption: {
                        value : "91",
                        label : pax.travellerDetails.passport.issuingCountryName,
                        alpha_2_code: pax.travellerDetails.passport.issuingCountryCode
                    },
                    passportExpiryDate: pax.travellerDetails.passport.expiryDate,
                    passportExpiryDateRawValue: pax.travellerDetails.passport.expiryDateRawValue,
                    frequentFlyerNumber: pax.travellerDetails.frequentFlyer[0].frequentFlyerNumber,
                    ffnSelectedOption: {
                        value: pax.travellerDetails.frequentFlyer[0].ac,
                        label: pax.travellerDetails.frequentFlyer[0].an
                    },
                    isExtrasExpanded: true
                })
            } else {
                const selectedOption = { value: '', label: 'Select Here' };
                this.setState({ ffnSelectedOption: selectedOption });
            }
    }

    componentWillReceiveProps(prevProps, nextProps) {
        if (prevProps.editPax) {
            let pax = prevProps.editPax[0];
            this.setState({
                honorific: pax.travellerDetails.title,
                firstName: pax.travellerDetails.firstName,
                lastName: pax.travellerDetails.lastName,
                dateValue: pax.travellerDetails.dateOfBirth,
                dateRawValue: pax.travellerDetails.dobRaw,
                number: pax.travellerDetails.passport.number,
                nationality: pax.travellerDetails.passport.nationality,
                selectedOption: {
                    value : "91",
                    label : pax.travellerDetails.passport.issuingCountryName,
                    alpha_2_code: pax.travellerDetails.passport.issuingCountryCode
                },
                passportExpiryDate: pax.travellerDetails.passport.expiryDate,
                passportExpiryDateRawValue: pax.travellerDetails.passport.expiryDateRawValue,
                frequentFlyerNumber: pax.travellerDetails.frequentFlyer[0].frequentFlyerNumber,
                ffnSelectedOption: {
                    value: pax.travellerDetails.frequentFlyer[0].ac,
                    label: pax.travellerDetails.frequentFlyer[0].an
                },
                isExtrasExpanded: true
            })
        }
    }

    toggleClickedHandler = () => {
        this.setState(prevState => {
            return {honorificSelectActive: !prevState.honorificSelectActive}
        })
    }

    closeHonorificSelectMenuHandler = () => {
        this.setState({
            honorificSelectActive: false
        })
    }

    onDateChange(event) {
        this.setState({dateRawValue: event.target.rawValue, isDobValid: true, dateValue: event.target.value}, () => {
            if(this.props.totalPaxConstant === 1 ) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        });
    }

    onDateChangeHandler(event) {
        this.setState({
            passportExpiryDateRawValue: event.target.rawValue,
            passportExpiryDate: event.target.value 
        }, () => {
            if(this.props.totalPaxConstant === 1) {
                this.props.onAddOnlyPax(this.state.honorific, this.state.firstName, this.state.lastName, 'adult', this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
            }
        });
    }

    render() {
        let paxType = null;

        if (this.props.adultCount > 0) {
            paxType = 'adult'
        } else if (this.props.childCount > 0) {
            paxType = 'child'
        } else if (this.props.infantCount > 0) {
            paxType = 'infant'
        }

        const params = new URLSearchParams(this.props.location.search);
        const isInt = JSON.parse(params.get("isInt"));

        let buttonAdd = (
            <Button 
                theme='Primary' 
                type='Add'
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    
                    if(this.state.honorific === "") {
                        this.setState({ isHonorificValid: false });
                        return;
                    }
                    if(this.state.firstName.trim() === "") {
                        this.setState({ isFirstNameValid: false });
                        return;
                    }
                    if(this.state.lastName.trim() === "" || this.state.lastName.length <= 2) {
                        this.setState({ isLastNameValid: false })
                        return;
                    }
                    if(this.props.lob !== "hotel") {
                        if(paxType === 'infant' || this.props.showDOB || isInt) {
                            if(moment(this.state.dateValue, 'DD/MM/YYYY').diff(moment(new Date(), "DD/MM/YYYY"), 'days') >= 0) {
                                this.setState({ isDobValid: false });
                                return;
                            }
                        }
                        if((this.props.showDOB || isInt) && paxType !== "infant") {
                            const previousDate = moment().subtract(12, "years");
                            const diff = moment(this.state.dateValue, 'DD/MM/YYYY').diff(previousDate, 'days');
                            if(paxType === 'adult' && diff > 0) {
                                this.setState({ isDobValid: false });
                                return;
                            }
                            // if(diff > 0) {
                            //     this.setState({ isDobValid: false });
                            //     return;
                            // }
                        }
                        if(paxType === 'infant') {
                            const lastTDate = moment(this.props.lastTDate).format('DD/MM/YYYY');
                            const previousDate = moment(lastTDate, 'DD/MM/YYYY').subtract(2, 'years');
                            const diff = moment(this.state.dateValue, 'DD/MM/YYYY').diff(previousDate, 'days');
                            if(diff < 0) {
                                this.setState({ isDobValid: false });
                                return; 
                            }
                        }
                        if((this.state.dateRawValue === "" && paxType === 'infant') || (this.state.dateRawValue === "" && this.props.showDOB)) {
                            this.setState({ isDobValid: false });
                            return;
                        }
                        for(let i = 0; i < this.props.passengers.length; i++) {
                            const passenger = this.props.passengers[i].travellerDetails;
                            const passengerName = passenger.title + passenger.firstName + passenger.lastName;
                            if(passengerName === (this.state.honorific + this.state.firstName + this.state.lastName)) {
                                return;   
                            }
                        }
                    }
                    
                this.setState({
                    firstName: '',
                    lastName: '',
                    honorific: '',
                    dateRawValue: '',
                    passportExpiryDate: '',
                    passportExpiryDateRawValue: '',
                    number: '',
                    nationality: '',
                    selectedOption: {
                        value : "91",
                        label : "India",
                        alpha_2_code: "IN"
                    },
                    isExtrasExpanded: false
                })
                if(this.props.lob === "hotel") {
                    this.props.onAddHotelPax(this.state.honorific, this.state.firstName, this.state.lastName, true);
                } else {
                    this.props.onAddPax(this.state.honorific, this.state.firstName, this.state.lastName, paxType, this.state.dateValue, this.state.dateRawValue, this.state.number, this.state.nationality, this.state.selectedOption, this.state.passportExpiryDate, this.state.passportExpiryDateRawValue, this.state.ffnSelectedOption, this.state.frequentFlyerNumber, true);
                }
                }}>
                <span className={`u-phoneHide`}>+ ADD</span>
                <span className={`u-phoneShow`}>ADD PASSENGER</span></Button>
        );
        let titleOptions = null;
        if(this.props.paxType === 'Adult') {
            titleOptions = paxMapping.slice(0, 3);
        } else {
            titleOptions = paxMapping.slice(3, 5);
        }

        const border = '1px solid var(--color-border)';
        const colorDark = "var(--color-grey-dark-1)";

        return (
            <React.Fragment>
                <form className={`u-flex u-height100Percent align-items-center justify-content-between u-relative phone-f-column phone-mb-0`}>
                    <div className={`${classes.FormRow} u-flex`}>
                        <div className={`u-flex ${classes.FormRowInner}`}>
                            <div className={`${classes.FormSmall} u-flex align-items-center`}>
                                <Tooltip showTooltip={!this.state.isHonorificValid} type="firstName" aria-label="Enter Title" />
                                <span className={[classes.Title, this.state.honorific !== '' ? classes.TitleActive : null].join(' ')}>Title</span>
                                <SelectMenu 
                                    mapping={titleOptions} 
                                    clicked={this.honorificSelectHandler} 
                                    value={this.state.honorific} 
                                    toggleClicked={this.toggleClickedHandler} 
                                    active={this.state.honorificSelectActive} 
                                    type='pax'
                                    isHonorificValid={this.state.isHonorificValid}
                                    closeSelect={this.closeHonorificSelectMenuHandler}/>
                            </div>
                            <div className={`${[classes.FormLarge, classes.FormUnique].join(' ')} u-flex align-items-center`}>
                                <Tooltip showTooltip={!this.state.isFirstNameValid} type="firstName" aria-label="Enter First Name" />
                                <InputMaterial 
                                    type='text'
                                    label='First Name' 
                                    alignment='left' 
                                    style={{borderBottom: !this.state.isFirstNameValid ? '2px solid #ff7d7d': `${border}`}}
                                    value={this.state.firstName} 
                                    onChange={(event) => this.inputChangeHandler(event, 1)} 
                                    onFocus={() => this.setState({isFirstNameValid: true})}
                                    name='firstName'/>
                            </div>
                        </div>
                        <div className={`${classes.FormLarge} u-flex align-items-center`}>
                            <Tooltip showTooltip={!this.state.isLastNameValid} type="lastName" aria-label="Enter valid Last Name" />
                            <InputMaterial 
                                type='text' 
                                label='Last Name' 
                                alignment='left' 
                                style={{borderBottom: !this.state.isLastNameValid ? '2px solid #ff7d7d': `${border}`}}
                                value={this.state.lastName} 
                                onChange={(event) => this.inputChangeHandler(event, 2)}
                                onFocus={() => this.setState({isLastNameValid: true})}
                                name='lastName'/>
                        </div>
                        {
                            this.props.showDOB || paxType === 'infant' || isInt ? <div className={`${classes.FormLarge} u-flex align-items-center u-relative`}>
                                <Tooltip showTooltip={!this.state.isDobValid} type="dob" aria-label="Enter Valid DOB" />
                                <div className={`u-relative u-width100Percent`}>
                                    <Cleave
                                        className={classes.CustomInput}
                                        options={{date: true, delimiter: '/', datePattern: ['d', 'm', 'Y']}}
                                        onChange={this.onDateChange.bind(this)}
                                        value={this.state.dateRawValue}
                                        placeholder={'MM/DD/YYYY'}
                                        />
                                    <span className={classes.Bar}></span>
                                    <InputLabel isActive>DOB</InputLabel>
                                </div>
                            </div> : null
                        }
                    </div>
                    {this.props.totalPaxConstant > 1 ? buttonAdd : null}
                </form>
                {this.props.ffnData || this.props.isPassport ? (
                <React.Fragment>
                  <div className="mt-4 mb-4">
                      <span className="u-cursorPointer u-fontSize13 u-textColorPrimary u-noUserSelect" onClick={this.onToggleExtras}>Add {this.props.isPassport ? 'Passport' : ""} {this.props.isPassport && this.props.ffnData ? 'and' : null} {this.props.ffnData ? "Frequent Flyer Number" : ""} (Optional)<span className={`ml-1 u-inlineBlock u-transition--transform200Spring`} style={{transform: this.state.isExtrasExpanded ? 'rotate(270deg)' : 'rotate(90deg)'}}><FontAwesomeIcon icon="caret-right" color={`${colorDark}`} size="1x" /></span></span>
                  </div>
                  <AnimakitExpander
                    expanded={this.state.isExtrasExpanded}
                    duration={250}
                    align="top">
                    <React.Fragment>
                      {this.props.isPassport ? (
                        <div className="mb-4">
                          <div className="mb-2">
                            <HeadingH3 size={13} weight="Medium" color="Dark">Passport Details</HeadingH3>
                          </div>
                          <PassportDetails
                            number={this.state.number} 
                            nationality={this.state.nationality}
                            selectedOption={this.state.selectedOption}
                            passportExpiryDateRawValue={this.state.passportExpiryDateRawValue}
                            inputHandler={this.inputHandler}
                            onHandleChange={this.onHandleChange}
                            onDateChangeHandler={this.onDateChangeHandler.bind(this)} />
                        </div>
                      ) : null}
                      {
                        this.props.ffnData ? <div>
                          <div className="mb-2">
                            <div className="phone-mb-2 phone-mt-2">
                                <HeadingH3 size={13} weight="Medium" color="Dark">Frequent Flyer Details</HeadingH3>
                            </div>
                            <HeadingH4 size={11} weight="Regular" color="Light">Please verify the credit of your frequent flyer miles at the airport check-in counter</HeadingH4>
                          </div>
                          <FrequentFlyerDetails
                            frequentFlyerNumber={this.state.frequentFlyerNumber}
                            selectedOption={this.state.ffnSelectedOption}
                            inputHandler={this.inputHandler}
                            onHandleChange={this.ffnHandleChange} 
                            data={this.props.ffnData.alliance} />
                        </div> : null
                      }
                    </React.Fragment>
                  </AnimakitExpander>
                </React.Fragment>
              ) : null}
            </React.Fragment>            
        );
    }
}

const mapStateToProps = state => {
    return {
        adultCount: state.farePrice.adultCount,
        childCount: state.farePrice.childCount,
        infantCount: state.farePrice.infantCount,
        paxCounter: state.farePrice.paxCounter,
        editPax: state.farePrice.editPax,
        passengers: state.farePrice.passengers,
        guests: state.hotels.guests,
        showDOB: state.farePrice.showDOB,
        lastTDate: state.farePrice.lastTDate,
        ffnData: state.farePrice.ffnData,
        isPassport: state.farePrice.isPassport,
        totalPaxConstant: state.farePrice.totalPaxConstant
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAddPax: (honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected) => dispatch(farePriceActions.addPax(honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected)),
        onAddOnlyPax: (honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected) => dispatch(farePriceActions.addOnlyPax(honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected)),
        onAddHotelPax: (honorific, firstName, lastName, isSelected) => dispatch(hotelActions.addHotelPax(honorific, firstName, lastName, isSelected)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Pax));


// WEBPACK FOOTER //
// ./src/components/Pax/Pax.js